// extracted by mini-css-extract-plugin
export var brand = "_33-9";
export var compact = "_33-6";
export var extraSmall = "_33-7";
export var icon = "_33-0";
export var large = "_33-4";
export var light = "_33-1";
export var medium = "_33-5";
export var outline = "_33-b";
export var primaryDark = "_33-a";
export var primaryLight = "_33-8";
export var primaryModern = "_33-c";
export var success = "_33-2";
export var successSolid = "_33-3";